import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Menu,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import { TASK_STATUS } from "__helpers/constants";
import { PRIORITY_LIST } from "__helpers/constants";
import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import { userService } from "_services/user.service";
import css from '../assets/css/closebtn.css';
const SURVEY_STATUS_OPTIONS = [
"VIEWED","SUBMITTED","DELIVERED","PENDING","SCHEDULED","DECLINED","CANCELLED"];
// const ASSIGNEE_OPTIONS = [
//   { id: 1, name: "John Smith" },
//   { id: 2, name: "Emily Johnson" },
//   { id: 3, name: "Michael Brown" },
//   { id: 4, name: "Sarah Williams" }
// ];
class FilterComponent extends React.Component {
  state = {
    priorities: [],
    ticketStatuses: [],
    assignees:[],
    surveyStatuses: [],
    taskDueDateFrom: "",
    taskDueDateTo: "",
    dueDateAnchorEl: null,
    assigneeList:[]
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      // Send all current filter states when any filter changes
      this.props.onFilterChange({
        priorities: this.state.priorities,
        ticketStatuses: this.state.ticketStatuses,
        surveyStatuses: this.state.surveyStatuses,
        startDate : this.state.taskDueDateFrom,
        endDate : this.state.taskDueDateTo,
        assignees:this.state.assignees
      });
    });
  };

  handleClearFilter = (filterName) => {
    this.setState({ [filterName]: filterName.includes('Date') ? '' : [] }, () => {
      // After clearing, send all current filter states
      this.props.onFilterChange({
        priorities: this.state.priorities,
        ticketStatuses: this.state.ticketStatuses,
        surveyStatuses: this.state.surveyStatuses,
        startDate : this.state.taskDueDateFrom,
        endDate : this.state.taskDueDateTo,
        assignees:this.state.assignees
      });
    });
  };

  handleDueDateClick = (event) => {
    this.setState({ dueDateAnchorEl: event.currentTarget });
  };

  handleDueDateClose = () => {
    this.setState({ dueDateAnchorEl: null });
  };

  handleDateChange = () => {
    // Send all current filter states including the date range
    this.props.onFilterChange({
      priorities: this.state.priorities,
      ticketStatuses: this.state.ticketStatuses,
      surveyStatuses: this.state.surveyStatuses,
      startDate: this.state.taskDueDateFrom,
      endDate: this.state.taskDueDateTo,
      assignees:this.state.assignees
    });
    this.handleDueDateClose();
  };

renderSelectedLimited = (selected) => {
  if (!selected || selected.length === 0) return "All";

// const assigneeList = this.state.assigneeList; // ✅ use this.state here
 const { assigneeList } = this.state;
  // Helper function to resolve name from list
  const getNameFromList = (value) => {
    let match =
      PRIORITY_LIST.find((p) => p.id === value) ||
      TASK_STATUS.find((s) => s.id === value) ||
       assigneeList.find((a) => String(a.assigneeId) === String(value));
    return match ? match.name : value;
  };

  const selectedNames = selected.map(getNameFromList);

  if (selectedNames.length === 1) return selectedNames[0];
  return `${selectedNames[0]}...`;
};
  async fetchAssignee() {
  
    let showNotification = {};
    const apiUrl = apiPath.GetAllAssignee
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
  
      if (response.status === 400) {
        //showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        //showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }
  
      const data = await response.json();

      console.log("Assignee response: ", response);
      console.log("Assignee Fetched: ", data);
      console.log("AssigneeFetched: ", response.data);
  
      this.setState({ assigneeList: data }); // <-- update surveys from API
  
      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
    //  showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }
  
  }
  componentDidMount(){
    this.fetchAssignee()
  }
  render() {
    const {
      priorities,
      ticketStatuses,
      surveyStatuses,
      taskDueDateFrom,
      taskDueDateTo,
      dueDateAnchorEl,
      assignees,
      assigneeList
    } = this.state;

    const openDueDate = Boolean(dueDateAnchorEl);

    return (
      <div className="status-btn-cover">
       <Box display="flex" flexDirection="row" width={1}>
  <Box pr={1.5} className="left-content-box">
    <div className="">
      <Box
        className="action-box patientListFilters"
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
      >
        {/* Priority */}
        <Box pl={1} className="box-filter filter-orderby">
          <Box  style={{ fontSize: '14px', fontWeight: '500' }}>Priority</Box>
          <FormControl variant="outlined" className="mat_select filter-select" style={{ minWidth: 250 }}>
            <Select
              multiple
              name="priorities"
              value={priorities}
              onChange={this.handleChange}
              renderValue={this.renderSelectedLimited}
              style={{
                height: 35, // Set the height for the input field
                display: 'flex',
                alignItems: 'center',
                border:'none'
              }}
                displayEmpty
              endAdornment={
                priorities.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleClearFilter('priorities');
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
              MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
            >
              {PRIORITY_LIST.map((priority) => (
                <MenuItem key={`${priority.id}-${priority.name}`} value={priority.id}>
                  {priority.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Task Status */}
        <Box pl={1} className="box-filter filter-orderby">
          <Box  style={{ fontSize: '14px', fontWeight: '500' }}>Task Status</Box>
          <FormControl variant="outlined" className="mat_select filter-select" style={{minWidth: 250  }}>
            <Select
              multiple
              name="ticketStatuses"
              value={ticketStatuses}
              onChange={this.handleChange}
              renderValue={this.renderSelectedLimited}
              style={{ height: 35,   border:'none' }}
              displayEmpty
              endAdornment={
                ticketStatuses.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleClearFilter('ticketStatuses');
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
              MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
            >
              {TASK_STATUS.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Due Date */}
        <Box pl={1} className="box-filter filter-orderby">
          <Box  style={{ fontSize: '14px', fontWeight: '500' }}>Due Date</Box>
          <FormControl variant="outlined" className="mat_select filter-select" style={{ minWidth: 250 }}>
            <div
              onClick={this.handleDueDateClick}
              style={{
                height: 35,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid #ccc",
                borderRadius: 4,
                padding: "0 14px",
                fontSize: "14px",
                background: "#fff",
                cursor: "pointer",
                borderRadius: '8px'
              }}
            >
              <span>
  {taskDueDateFrom && taskDueDateTo
    ? `${new Date(taskDueDateFrom).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })} to ${new Date(taskDueDateTo).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })}`
    : taskDueDateFrom
    ? ` ${new Date(taskDueDateFrom).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })}`
    : taskDueDateTo
    ? ` ${new Date(taskDueDateTo).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })}`
    : 'All'}
</span>


              {(taskDueDateFrom || taskDueDateTo) && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleClearFilter('taskDueDateFrom');
                    this.handleClearFilter('taskDueDateTo');
                  }}
                >
                  <Clear fontSize="small" />
                </IconButton>
              )}
            </div>
            <Menu
              anchorEl={dueDateAnchorEl}
              open={openDueDate}
              onClose={this.handleDueDateClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              getContentAnchorEl={null}
            >
              <Box display="flex" p={2} flexDirection="column">
                <Box display="flex" mb={2}>
                  <Box mr={2}>
                    <label style={{ fontSize: "12px", margin: "5px" }}>From</label>
                    <input
                      type="date"
                      value={taskDueDateFrom}
                      onChange={(e) =>
                        this.setState({ taskDueDateFrom: e.target.value })
                      }
                      style={{
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </Box>
                  <Box>
                    <label style={{ fontSize: "12px", margin: "5px" }}>To</label>
                    <input
                      type="date"
                      value={taskDueDateTo}
                      onChange={(e) =>
                        this.setState({ taskDueDateTo: e.target.value })
                      }
                      style={{
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </Box>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                  <button
                    onClick={this.handleDateChange}
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#1976d2",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Apply
                  </button>
                </Box>
              </Box>
            </Menu>
          </FormControl>
        </Box>

        {/* Survey Status */}
        <Box pl={1} className="box-filter filter-orderby">
          <Box  style={{ fontSize: '14px', fontWeight: '500' }}>Survey Status</Box>
          <FormControl variant="outlined" className="mat_select filter-select" style={{ minWidth: 250  }}>
            <Select
              multiple
              name="surveyStatuses"
              value={surveyStatuses}
              onChange={this.handleChange}
              renderValue={this.renderSelectedLimited}
              style={{ height: 35 ,   border:'none'}}
              displayEmpty
              endAdornment={
                surveyStatuses.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleClearFilter('surveyStatuses');
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
              MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
            >
              {SURVEY_STATUS_OPTIONS.map((opt) => (
                <MenuItem key={opt} value={opt}>
                  <ListItemText primary={opt} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
          <Box pl={1} className="box-filter filter-orderby">
          <Box  style={{ fontSize: '14px', fontWeight: '500' }}>Assignee</Box>
          <FormControl variant="outlined" className="mat_select filter-select" style={{ minWidth: 250  }}>
            <Select
              multiple
              name="assignees"
              //value={assignees}
              value={this.state.assignees} // selected IDs
              onChange={this.handleChange}
              renderValue={this.renderSelectedLimited}
              style={{ height: 35 ,   border:'none'}}
              displayEmpty
              endAdornment={
                assignees.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleClearFilter('assignees');
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
              MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
            >
              {/* {assigneeList.map((opt,index) => ( */}
                 {assigneeList.map((opt) => (
                <MenuItem key={opt.assigneeId} value={opt.assigneeId}>
                  <ListItemText primary={opt.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </div>
  </Box>
</Box>
      </div>
    );
  }
}

export default FilterComponent;